import type from './source.types'
import * as utils from './source.utils'

export const initialState = {
  currentSource: null,
  list: {
    data: [],
    header: [],
    body: [],
    limit: 50,
    page: 1,
    total: 1,
  },
  errors: {
    current: {},
    data: [],
  },
  isLoading: false,
}

const sourceReducer = (state = initialState, action) => {
  switch (action.type) {
    case type.SOURCE_TRY:
      return {
        ...state,
        isLoading: true,
      }

    case type.SET_CURRENT_SOURCE:
      return {
        ...state,
        currentSource: action.payload,
        isLoading: false,
      }

    case type.LIST_SUCCESS: {
      const list = utils.formatData(action.payload)
      return { ...state, isLoading: false, list }
    }

    case type.ADD_SOURCE: {
      const data = [...state.list.data, action.payload.data]
      const list = utils.formatData({ data })

      return {
        ...state,
        isLoading: false,
        list,
      }
    }

    case type.UPDATE_SOURCE: {
      const index = state.list.data.findIndex(
        source => source.id === Number(action.payload.id)
      )

      if (index !== -1) {
        state.list.data[index] = {
          ...action.payload.data,
          id: Number(action.payload.id),
        }

        const list = utils.formatData({ data: state.list.data })
        return { ...state, list, isLoading: false }
      }

      return state
    }

    case type.DELETE_SOURCE: {
      const id = Number(action.payload)
      const data = state.list.data.filter(source => source.id !== id)
      const body = state.list.body.filter(source => source.id !== id)
      if (data) {
        return {
          ...state,
          isLoading: false,
          list: {
            ...state.list,
            data,
            body,
          },
        }
      }
      return state
    }

    case type.SOURCE_FAILED:
      const errors = utils.addError(state.errors, action)
      return { ...state, errors: { ...errors }, isLoading: false }

    case type.CLEAR_CURRENT_ERROR_SOURCE: {
      return {
        ...state,
        errors: {
          ...state.errors,
          current: {},
        },
        isLoading: false,
      }
    }

    default:
      return state
  }
}

export default sourceReducer
